<template>
  <div v-if="visible" class="image-block">
    <figure
        class="image-block__figure"
        :class="{
        'image-block__figure--landscape': props.data.orientation === 'landscape',
        'image-block__figure--portrait': props.data.orientation === 'portrait',
      }"
    >
      <AppImageFigure :data="data" classes="image-figure--full-width" :renditions="renditions as TImageRendition[]" :contain="props.data.contain" />
    </figure>
  </div>
</template>
<script setup lang="ts">
import {computed} from 'vue'
import {TImageBlock} from '~/types/block-types'
import {isVisible} from '~/utils/visibility'
import type {TImageRendition} from '~/types/other-types'

const props = defineProps<{
  data: TImageBlock,
}>()

const visible = computed(() => {
  return isVisible(props.data)
})

const renditions = computed(() => {
  const orientationMultiplier = (props.data.orientation === 'landscape') ? 0.563 : 1.25

  return [
    {width: props.data.contain ? 'auto' : 550, height: props.data.contain ? 'auto' : Math.floor(550 * orientationMultiplier), breakpoint: 'xs'},
    {width: props.data.contain ? 'auto' : 700, height: props.data.contain ? 'auto' : Math.floor(700 * orientationMultiplier), breakpoint: 'sm'},
    {width: props.data.contain ? 'auto' : 800, height: props.data.contain ? 'auto' : Math.floor(800 * orientationMultiplier), breakpoint: 'md'},
    {width: props.data.contain ? 'auto' : 900, height: props.data.contain ? 'auto' : Math.floor(900 * orientationMultiplier), breakpoint: 'lg'},
    {width: props.data.contain ? 'auto' : 1000, height: props.data.contain ? 'auto' : Math.floor(1000 * orientationMultiplier), breakpoint: 'xxl'}
  ]
})
</script>

<style scoped lang="postcss">
.image-block {
  @mixin app-layout-container;
  @mixin app-block-margins;

  &__figure {
    grid-column: 1 / -1;

    @media (--md) {
      &--portrait {
        grid-column: span 8 / span 8;
        grid-column-start: 3;
      }
    }

    @media (--lg) {
      &--portrait {
        grid-column: span 6 / span 6;
        grid-column-start: 4;
      }
    }

    @media (--xl) {
      &--landscape {
        grid-column: span 10 / span 10;
        grid-column-start: 2;
      }
    }
  }
}
</style>
